import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  NotifyRequestOwnerDto,
  SendManualNotificationDto,
  SendNewAppointmentNotificationDto
} from './notifications.dto';
import { Notification } from './notifications.type';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  apiUrl: string = `${environment.apiBase}`;

  constructor(private http: HttpClient) {}

  send(input: SendManualNotificationDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/send/`, input);
  }

  sendNewAppointmentNotification(input: SendNewAppointmentNotificationDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/send/newAppointment/`, input);
  }

  sendNotificationToRequestOwner(input: NotifyRequestOwnerDto) {
    return this.http.post(`${this.apiUrl}/board/notifications/notifyOwner/`, input);
  }

  getEmployeeNotifications() {
    return this.http.get(`${this.apiUrl}/board/notifications`);
  }

  toggleNotificationReadStatus(notificationId: number){
    return this.http.post(`${this.apiUrl}/board/notifications/${notificationId}/toggle-read`, {});
  }
}
